import { map, type Observable } from 'rxjs';
import {
  createProductTourView,
  type TourRegistry,
} from '@ardoq/product-tours-host';
import { noTourTracking, type TrackTourEvent } from '@ardoq/product-tours';
import { i18nLocale$ } from 'streams/i18nLocale$';
import { currentUser$ } from 'streams/currentUser/currentUser$';
import { trackTourEvent } from 'productTours/trackTourEvent';
import { presentationNavigatorTourDefinition$ } from 'productTours/presentationNavigator/presentationNavigatorTour';

const tourRegistry: TourRegistry = {
  'presentation-navigator': presentationNavigatorTourDefinition$,
};

// An anonymous public-presentation viewer has no session, and
// /api/track/event rejects sessionless ardoq-front events (PR #31321).
const trackTourEvent$: Observable<TrackTourEvent> = currentUser$.pipe(
  map(currentUser => (currentUser?._id ? trackTourEvent : noTourTracking))
);

export const ProductTour = createProductTourView(
  tourRegistry,
  i18nLocale$,
  trackTourEvent$
);
